import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Tooltip } from '@mui/material';
import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { queryKeyBuilder } from '~/data/utils/helpers/query-key.builder';
import { dazzler } from '~/data/dazzler-api';
import { filter, join, map, pipe } from 'remeda';

export type FileProcessingInfoProps = {
  clientId: string;
  reportId: string;
  reportFileId: string;
  // Processing Log context
  context: string;
  severity: 'Error';
};

const queryKey = (clientId: string, reportId: string, fileId: string) =>
  queryKeyBuilder('base', 'clients', clientId, 'reports', reportId, 'files', fileId);

export function FileProcessingInfo({ clientId, reportId, reportFileId, context, severity }: FileProcessingInfoProps) {
  const [open, setOpen] = useState(false);

  const { data: logs } = useQuery({
    queryKey: queryKey(clientId, reportId, reportFileId),
    queryFn: async function fetchProcessingLogs({ signal }) {
      const response = await dazzler.reports.listReportFileProcessingLogs(
        {
          clientId,
          reportId,
          fileId: reportFileId,
          sort: 'Timestamp',
          direction: 'DESC',
          limit: 10,
          context,
          severity,
        },
        { signal },
      );

      return response.data;
    },
    enabled: open,
    useErrorBoundary: false,
  });

  const messages = pipe(
    logs?.items ?? [],
    map((x) => x.message),
    filter((x) => !!x),
    map((x) => <li>{x}</li>),
  );
  return (
    <Tooltip open={open} onClose={() => setOpen(false)} onOpen={() => setOpen(true)} title={<ul>{messages}</ul>}>
      <InfoOutlinedIcon />
    </Tooltip>
  );
}
